import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import { padding } from "polished";
import React from "react";

import { Container } from "@brexhq/next/src/components/layout/Container/Container";
import { Link } from "@brexhq/next/src/components/shared/Link";
import { blocksToText } from "@brexhq/shared/utils/sanity/blocksToText";

import type { LinkListItemProps } from "./LinkListItem";

const ListItemLink = styled(Link)(({ theme }) => ({
  ...theme.typography.BodySmallSB,
  ...padding(theme.spacing.SML.xsml, theme.spacing.SML.sml),
  gap: theme.spacing.SML.xxsml,

  display: "none",
  [theme.breakpoints.nav.SML]: {
    display: "grid",
  },
}));

const IconContainer = styled.div(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  color: theme.colors.content.primary,
  svg: {
    height: 16,
    width: 16,
  },
}));

const Subtitle = styled.div(({ theme }) => ({
  ...theme.typography.DetailLargeM,
  color: theme.colors.content.tertiary,
}));

export default function LinkListItemMobile({
  link: { text, link, subtitle, icon, subtitleV2Raw },
}: LinkListItemProps) {
  const subtitleContent =
    subtitleV2Raw && subtitleV2Raw?.length > 0
      ? blocksToText(subtitleV2Raw)
      : subtitle;
  const { colors } = useTheme();
  return (
    <ListItemLink
      modifier="unstyled"
      to={link?.to || link?.toExternal || link?.hash || "#"}
      noFollow={link.noFollow}
      label={text}
      component="Navigation LinkListModule (mobile)"
    >
      <Container display="flex" gap="xsml">
        {icon && (
          <IconContainer dangerouslySetInnerHTML={{ __html: icon.mono }} />
        )}
        <div style={{ color: colors.content.primary }}>{text}</div>
      </Container>
      {subtitleContent && <Subtitle>{subtitleContent}</Subtitle>}
    </ListItemLink>
  );
}
